// removed by extract-text-webpack-plugin
module.exports = {"summary-adjustment":"app-pages-Inventory-Adjustment-SummaryAdjustment-__SummaryAdjustment___15KHM","amount":"app-pages-Inventory-Adjustment-SummaryAdjustment-__SummaryAdjustment___2s7Ui","title":"app-pages-Inventory-Adjustment-SummaryAdjustment-__SummaryAdjustment___2qY0J"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Inventory/Adjustment/SummaryAdjustment/SummaryAdjustment.css
// module id = 2126
// module chunks = 0